import { motion } from 'framer-motion';
import { SALONS } from './data';

// VISIT — two large gallery "wall plates" with appointment form.
export default function Visit() {
  return (
    <div className="bg-[#F4F1EA] text-[#0A0A0A]">
      <section className="pt-12 pb-12 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-[#0A0A0A]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B53024] mb-4">— Two galleries</p>
        <h1 className="font-serif text-[44px] sm:text-[64px] lg:text-[88px] leading-[1.02] tracking-tight">Come in. <span className="italic text-[#B53024]">It is quiet</span>.</h1>
      </section>

      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-20 grid md:grid-cols-2 gap-px bg-[#0A0A0A]/15">
        {SALONS.map((s, i) => (
          <motion.div key={s.city} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
            className="bg-[#F4F1EA] p-12 lg:p-16">
            <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B53024] mb-3">Gallery 0{i + 1}</p>
            <h2 className="font-serif text-6xl lg:text-7xl leading-none">{s.city}</h2>
            <p className="font-serif italic text-2xl text-[#0A0A0A]/55 mt-1">est. {i === 0 ? '1981' : '1994'}</p>
            <div className="space-y-5 mt-10 text-base lg:text-lg text-[#0A0A0A]/85 leading-[1.7]">
              <p>{s.addr}</p>
              <p className="text-[#0A0A0A]/55">{s.hours}</p>
              <p className="font-mono text-sm">{s.tel}</p>
            </div>
            <div className="mt-10 aspect-[4/3] bg-[#EDE6D8] flex items-center justify-center border border-[#0A0A0A]/10">
              <p className="font-serif italic text-xl text-[#0A0A0A]/40">— {s.city} Gallery floorplan —</p>
            </div>
          </motion.div>
        ))}
      </section>

      {/* Appointment form — narrow column */}
      <section className="bg-[#0A0A0A] text-[#F4F1EA]">
        <div className="max-w-[820px] mx-auto px-8 lg:px-14 py-24">
          <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B53024] mb-4">— Private viewing</p>
          <h2 className="font-serif text-4xl lg:text-6xl leading-tight">A room <span className="italic text-[#B53024]">to yourself</span>.</h2>
          <p className="font-serif italic text-lg text-[#F4F1EA]/65 mt-6 max-w-lg">We open early or stay late for serious collectors. Tell us what you would like to see and we will have it ready, with a curator on hand.</p>
          <form className="mt-12 space-y-6" onSubmit={(e) => e.preventDefault()}>
            <input data-testid="art-visit-name" placeholder="Your name" className="w-full bg-transparent border-b border-[#F4F1EA]/30 py-3 outline-none focus:border-[#B53024] text-base placeholder:text-[#F4F1EA]/30" />
            <input type="email" placeholder="Email" className="w-full bg-transparent border-b border-[#F4F1EA]/30 py-3 outline-none focus:border-[#B53024] text-base placeholder:text-[#F4F1EA]/30" />
            <div className="grid grid-cols-2 gap-6">
              <select className="bg-transparent border-b border-[#F4F1EA]/30 py-3 outline-none focus:border-[#B53024] text-base text-[#F4F1EA]/85">
                <option className="bg-[#0A0A0A]">Gallery — New York</option>
                <option className="bg-[#0A0A0A]">Gallery — London</option>
              </select>
              <input type="date" className="bg-transparent border-b border-[#F4F1EA]/30 py-3 outline-none focus:border-[#B53024] text-base text-[#F4F1EA]/85" />
            </div>
            <textarea rows="3" placeholder="Lots or works of interest" className="w-full bg-transparent border-b border-[#F4F1EA]/30 py-3 outline-none focus:border-[#B53024] resize-none text-base placeholder:text-[#F4F1EA]/30" />
            <button type="button" data-testid="art-visit-submit" className="bg-[#B53024] text-[#F4F1EA] px-8 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#F4F1EA] hover:text-[#0A0A0A] transition-colors">Request appointment →</button>
          </form>
        </div>
      </section>
    </div>
  );
}
